import { getCmsApiBaseUrl } from "@/lib/cmsBase";

// Tiny CMS helpers for KB / Product page / Solution page.
// All three talk directly to Strapi.
const API = getCmsApiBaseUrl();

async function json(path) {
  const r = await fetch(`${API}${path}`);
  if (!r.ok) {
    const err = new Error(`${r.status} ${r.statusText}`);
    err.status = r.status;
    throw err;
  }
  return r.json();
}

// --- KB ---
export const fetchKbCategories = () => json(`/kb-categories`);
export const fetchKbList = (category) =>
  json(`/kb-articles?pagination[pageSize]=200&publicationState=live&populate=*${
    category && category !== "all" ? `&filters[category][slug][$eq]=${encodeURIComponent(category)}` : ""
  }`);
export const fetchKbArticle = async (slug) => {
  const data = await json(`/kb-articles?filters[slug][$eq]=${encodeURIComponent(slug)}&publicationState=live&populate=*`);
  const entry = data?.data?.[0] || null;
  return entry ? { data: entry } : { data: null };
};

// --- Dynamic product / solution pages ---
export const fetchProductPage = async (slug) => {
  const data = await json(`/product-pages?filters[slug][$eq]=${encodeURIComponent(slug)}&publicationState=live&populate=*`);
  const entry = data?.data?.[0] || null;
  return entry ? { data: entry } : { data: null };
};

export const fetchSolutionPage = async (slug) => {
  const data = await json(`/solution-pages?filters[slug][$eq]=${encodeURIComponent(slug)}&publicationState=live&populate=*`);
  const entry = data?.data?.[0] || null;
  return entry ? { data: entry } : { data: null };
};

// Helper: flatten Strapi v4 envelope into a plain object.
//   { id, attributes:{...} }  →  { id, ...attributes }
export function flatten(node) {
  if (!node) return null;
  if (Array.isArray(node)) return node.map(flatten);
  if (node && typeof node === "object") {
    if ("attributes" in node) {
      return { id: node.id, ...flatten(node.attributes) };
    }
    if (Object.keys(node).length === 1 && "data" in node) {
      return flatten(node.data);
    }
    const out = {};
    for (const [key, value] of Object.entries(node)) {
      out[key] = flatten(value);
    }
    return out;
  }
  return node;
}
